/* Noromega – fri frakt-boksen glir bort når man scroller ned i handlekurven, og kommer bare tilbake når man er helt i toppen */
(function () {
  if (window.nmShipInit) return;
  window.nmShipInit = true;

  var last = 0;
  var lockUntil = 0;

  function setMini(drawer, on) {
    if (drawer.classList.contains('nm-scrolled') === on) return;
    drawer.classList.toggle('nm-scrolled', on);
    lockUntil = Date.now() + 450; /* ignorer scroll-hopp mens boksen animeres */
  }

  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || el.nodeType !== 1 || !el.closest) return;
    var drawer = el.closest('cart-drawer');
    if (!drawer || el.classList.contains('nm-recs__list')) return;
    last = el.scrollTop;
    decide(drawer, el);
  }, true);

  /* Boksen vises bare helt i toppen, så den aldri dekker et produkt */
  function decide(drawer, el) {
    var wait = lockUntil - Date.now();
    if (wait > 0) { clearTimeout(drawer._nmT); drawer._nmT = setTimeout(function () { decide(drawer, el); }, wait + 20); return; }
    var y = el.scrollTop;
    if (y > 24) setMini(drawer, true);
    else if (y < 4) setMini(drawer, false);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nm-ship-mini]');
    if (!btn) return;
    var drawer = btn.closest('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('cart-drawer-items, .drawer__contents').forEach(function (s) {
      if (s.scrollTop > 0) s.scrollTo({ top: 0, behavior: 'smooth' });
    });
    setMini(drawer, false);
  });

  /* Når handlekurven tegnes på nytt (antall endret, vare lagt til), start med full boks */
  function watch() {
    document.querySelectorAll('cart-drawer').forEach(function (drawer) {
      if (drawer.dataset.nmShipWatch) return;
      drawer.dataset.nmShipWatch = '1';
      new MutationObserver(function () {
        var s = drawer.querySelector('cart-drawer-items');
        if (!s || s.scrollTop < 12) { drawer.classList.remove('nm-scrolled'); last = 0; }
      }).observe(drawer, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
